const ids = [
  1711961340000, 1712048340000, 1712308020000, 1712308440000, 1715842800000,
  1715852280000, 1715846400000, 1715766240000, 1715760000000, 1715680680000,
  1715673600000, 1715162520000, 1715155200000, 1715076360000, 1714990080000,
  1714903740000, 1714993200000, 1714649340000, 1714644000000, 1714217520000,
  1714212000000, 1714208400000, 1714131780000, 1714045800000, 1714039200000,
  1713873420000, 1713787140000, 1713780000000, 1713776400000, 1713528180000,
  1713441840000, 1713355560000, 1713351600000, 1713269580000, 1712924460000,
  1712916000000, 1712665440000, 1712579100000, 1712393100000, 1711789560000,
  1711703580000, 1711617480000, 1711531140000, 1710926640000, 1710750060000,
  1710486000000, 1710491520000, 1710405180000, 1710232560000, 1710146280000,
  1710140400000, 1709714460000, 1709708400000, 1709628180000, 1709622000000,
  1709541900000, 1709455620000, 1709369340000, 1709283000000, 1716809700000,
  1716550620000, 1716548400000, 1716544800000, 1716541200000, 1716464520000,
  1716458400000, 1716292080000, 1716285600000, 1709209200000, 1709122860000,
  1709118000000, 1708777440000, 1708668000000, 1708604940000, 1708599600000,
  1708518660000, 1708432320000, 1708426800000, 1708346040000, 1708086960000,
  1708000620000, 1707914280000, 1707908400000, 1707828000000, 1707741660000,
  1707482520000, 1707476400000, 1707472800000, 1707050640000, 1706964300000,
  1706791620000, 1706785200000,
]

const Error = ({ errorText }) => {
  return (
    <div>
      {errorText}
      <div>
        {ids.map((id) => (
          <div key={id}>
            <a href={`?id=${id}`}>go to {id}</a>
          </div>
        ))}
      </div>
    </div>
  )
}

export default Error
